import { Card } from "./dtos/Card.schema";
import axios from "axios";
import { AxiosResponse } from "axios";

export const assignStationsToCard = async (
  cardId: string, 
  addedStations: string[]
): Promise<AxiosResponse> => {    
  return await axios.put<Card>(`/cards/${cardId}/stations`, {
    addedStations: addedStations,
  }, {
    validateStatus: () => true // Accept any status code without throwing
  });
};

export const getCardAssignments = async (): Promise<Record<string, string[]>> => {
  const res = await axios.post<Record<string, string[]>>(
    "/cards/station-assignments"
  );
  return res.data;
};